import {React, Component} from "react";
import {Button, Input, FormLabel, InputLabel, Grid, FormGroup, FormControl, Box} from "@material-ui/core";
import $ from "jquery";
class NameCharacter extends Component{
    constructor(props) {

        super(props);
        const {child} = this.props.form_data;
        this.state = child

    }
    gender_clicked = (value) => {
        // let target = event.target;
        // let value = target.attributes['data-val'].value;
        // $('#gender_input').val(value);
        // this.setState({
        //     gender: value,
        // });
        this.form_validator({
            target: {
                name: 'gender',
                value: value,
            }
        })

    };
    gender;
    child_name;
    componentDidMount() {
        if(this.props.form_data.child_name && this.props.form_data.gender){
            this.props.handle_state_change({
                next_button_disabled: false,
            })
        }else{
            this.props.handle_state_change({
                next_button_disabled: true,
            })
        }
    }

    form_validator = event => {
        let state = this.state;
        state[event.target.name] = event.target.value;
        if (state.child_name && state.gender !== undefined) {
            this.props.handle_change({
                target: {
                    name: 'child',
                    value: state,
                }
            });
            this.props.handle_state_change({
                next_button_disabled: false,
            });
            // this.setState({[event.target.name]: event.target.value});

        } else {
            this.props.handle_state_change({
                next_button_disabled: true,
            })
        }
        this.setState(state);

    };


    render() {
        return (
            <Box display={'flex'} justifyContent="center">
            <Grid item>
                <h1>
                    Create your Personalised Character
                </h1>
                <Grid container>
                <FormControl>
                    <InputLabel>Child's Name</InputLabel>
                    <Input type={"text"} name="child_name" value={this.state.child_name}
                           onChange={this.form_validator}/>

                </FormControl>
                </Grid >

                    <Grid container style={{marginTop: '2em'}}>
                        <Grid container><InputLabel>Gender</InputLabel></Grid>

                        <FormControl>
                        <Grid container id={'gender_choices'}>

                            <Grid item xs={6}><Button style={{marginRight: '1em'}} variant="outlined" color="primary" id={this.state.gender === 'Boy' ?'selected': ''} data-val='Boy' onClick={()=>this.gender_clicked('Boy')}>Boy</Button></Grid>
                            <Grid item xs={6}><Button variant="outlined" color="primary" id={this.state.gender === 'Girl' ?'selected': ''} data-val='Girl' onClick={()=>this.gender_clicked('Girl')}>Girl</Button></Grid>
                        </Grid>
                    </FormControl>
                    </Grid>
            </Grid>

            </Box>
        );
    }
}



export default NameCharacter
